import type { Account } from './account.ts';
import type { AdUnit } from './adUnit.ts';
import type { AppCategory } from './appCategory.ts';
import type { EnrichedBlockedSeats } from './blockedSeats.ts';
import type { Brand } from './brand.ts';
import type { Buyer } from './buyer.ts';
import type { CommercialAgreementApi } from './commercialAgreement.ts';
import type { CreativeInfoApi } from './creativeInfo.ts';
import type { DealApi } from './deal.ts';
import type { Domain } from './domain.ts';
import type { FeeApi } from './fee.ts';
import type { FloorRuleApi } from './floorrule.ts';
import type { BidderOrder } from './gqlTypes.ts';
import type { ConstValues } from './helpers.ts';
import type { LineItem } from './lineItem.ts';
import type { Seat } from './seat.ts';
import type { SiteApi } from './site.ts';
import type { User } from './user.ts';

export const Resource = {
  ACCOUNT: 'account',
  ADUNIT: 'adunit',
  APP_CATEGORY: 'appcategory',
  BLOCKED_SEATS: 'blockedseats',
  BRAND: 'brand',
  BRAND_FLOOR: 'floorrule',
  BUYER: 'buyer',
  COMMERCIAL_AGREEMENT: 'commercialagreement',
  CREATIVE_REVIEW: 'creativereview',
  DEAL: 'deal',
  DOMAIN: 'domain',
  FEE_CAP: 'fee',
  LINEITEM: 'lineitem',
  ORDER: 'order',
  SEAT: 'seat',
  SITE: 'site',
  USER: 'user',
} as const;
export type Resource = ConstValues<typeof Resource>;

export interface ResourcesMap {
  [Resource.ACCOUNT]: Account;
  [Resource.ADUNIT]: AdUnit;
  [Resource.APP_CATEGORY]: AppCategory;
  [Resource.BLOCKED_SEATS]: EnrichedBlockedSeats;
  [Resource.BRAND]: Brand;
  [Resource.BRAND_FLOOR]: FloorRuleApi;
  [Resource.BUYER]: Buyer;
  [Resource.COMMERCIAL_AGREEMENT]: CommercialAgreementApi;
  [Resource.CREATIVE_REVIEW]: CreativeInfoApi & { publisher_ids: string };
  [Resource.DEAL]: DealApi;
  [Resource.DOMAIN]: Domain;
  [Resource.FEE_CAP]: FeeApi;
  [Resource.LINEITEM]: LineItem;
  [Resource.ORDER]: Omit<BidderOrder, '__typename'>;
  [Resource.SEAT]: Seat;
  [Resource.SITE]: SiteApi;
  [Resource.USER]: User;
}

export const ResourceOperation = {
  CREATE: 'create',
  UPDATE: 'update',
  CLONE: 'clone',
  EXPIRE: 'expire',
} as const;

export type ResourceOperationType = ConstValues<typeof ResourceOperation>;
